import { getConfig } from "../configuration";
import { PublicClientApplication, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

const getMsalConfig = (): Configuration => ({
  auth: {
    ...getConfig().auth,
  } as Configuration["auth"],
  cache: {
    // The task-pane reload on an app switch wipes sessionStorage, MSAL's default, taking the
    // account and token cache with it. localStorage survives it.
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
  },
});


let msalInstance: PublicClientApplication | null = null;
let initialization: Promise<void> | null = null;

export function getMsalInstance(): PublicClientApplication {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(getMsalConfig());
  }
  return msalInstance;
}

/**
 * The task pane must not render until this resolves. `MsalProvider` calls `getAllAccounts()` while
 * rendering itself, and MSAL throws `uninitialized_public_client_application` from any API reached
 * before initialization - harmless when the cache was empty, fatal once it holds real accounts.
 */
export async function initializeMsal(): Promise<PublicClientApplication> {
  const instance = getMsalInstance();
  if (!initialization) {
    initialization = instance.initialize();
  }
  await initialization;
  return instance;
}

export default getMsalInstance;